import React, {useState, useEffect, Fragment} from 'react'
import {EuiFormRow, EuiFieldText, EuiFieldPassword} from '@elastic/eui'
import BeatLoader from "react-spinners/BeatLoader";
import Axios from 'axios';
import CONFIG from '../../../../config';
import { EuiCheckbox } from '@elastic/eui';
import { EuiIcon } from '@elastic/eui';
import qrcode from 'qrcode-generator';

const UserTable = () => {

    const [content, changeContent] = useState(null)
    const [users, changeUsers] = useState([])
    const [modal, changeModal] = useState({
        title: null,
        body: null,
        aciton: null
    })

    const handleDelete = (username) => () => {
        if (window.confirm(`Confirm deletion of '${username}'?`)){
            Axios.get(CONFIG.api.userDelete(username))
                .then( resp => {
                    changeUsers(users.filter(user => user.u !== username))
                    alert(`${username} deleted`)

                })
                .catch( err => alert(`Could not delete ${username}`))
        }        
    }

    const handleUpdatePassword = (username) => () => {
        let password = ""

        changeModal({
            title: `Modify ${username}`,
            body: <Fragment>
                <EuiFormRow label="Password">
                    <EuiFieldPassword
                        placeholder="password"
                        onChange={(e) => 
                            password = e.target.value
                        }
                    />
                </EuiFormRow>                
            </Fragment>,
            action: () => {
                Axios.post(CONFIG.api.userCreate, {
                    "username": username,
                    "password": password
                }).then( _ => {
                    alert('User modified successfully! Please note 2FA has also been reset if enabled')
                    window.$("#userManagementModal").modal('hide')
                })
            }
        })
        window.$('#userManagementModal').modal('show')
    }

    const handleCreateUser = () => {
        let username = ""
        let password = ""

        changeModal({
            title: "Create New User",
            body: <Fragment>
                <EuiFormRow label="Username">
                    <EuiFieldText 
                        name="username" 
                        onChange={(e) => {
                            username = e.target.value
                        }}
                    />
                </EuiFormRow>
                <EuiFormRow label="Password">
                    <EuiFieldPassword
                        placeholder="password"
                        onChange={(e) => 
                            password = e.target.value
                        }
                    />
                </EuiFormRow>                
            </Fragment>,
            action: () => {
                Axios.post(CONFIG.api.userCreate, {
                    "username": username,
                    "password": password
                }).then( _ => {
                    alert('User created successfully!')
                    window.$("userManagementModal").modal('hide')
                    changeUsers([...users, {
                        u: username,
                        "2fa": false
                    }])
                })
            }
        })
        window.$('#userManagementModal').modal('show')
    }

    const handleToggle2FA = (username) => (e) => {
        switch (CONFIG.mode) {
            case "PROD":
            case "DEV":
                Axios.post(CONFIG.api.toggle2FA, {
                    u: username
                }).then(_ => alert("2FA successfully toggled"))
                break;
            default:
                break;            
        }

        const newUsers = users.map(user => user.u === username ? {
                    ...user,
                    '2fa': e.target.checked
                }
            :
                user
        )

        changeUsers(newUsers)
    }

    const handleShow2faQR = (username) => () => {
        const typeNumber = 0;
        const errorCorrectionLevel = 'H';
        const qr = qrcode(typeNumber, errorCorrectionLevel);        

        switch (CONFIG.mode) {
            case "DEV":
            case "PROD":
                Axios.post(CONFIG.api.get2FASecret, {
                    u: username
                }).then(resp =>{
                    qr.addData(`otpauth://totp/CyberSift:${username}?secret=${resp.data['2faSecret']}&issuer=CyberSift`);
                    qr.make();
                    document.getElementById('qrCode').innerHTML = qr.createImgTag(6);
                    window.$("#user2faQr").modal('show')
                })
                break;
        
            default:
                qr.addData(`otpauth://totp/CyberSift:${username}?secret=JBSWY3DPEHPK3PXP&issuer=CyberSift`);
                qr.make();
                document.getElementById('qrCode').innerHTML = qr.createImgTag(6);
                window.$("#user2faQr").modal('show')
                break;
        }
                
    }

    useEffect(()=>{
        changeContent( <div className="col-md-12 col-6">
        <table className="table table-hover">
                <thead>
                <tr>
                    <th scope="col">
                        <h5>Username</h5>
                    </th>
                    <th scope="col">
                        <h5>2FA</h5>
                    </th>
                    <th scope="col">
                        <h5>Actions</h5>
                    </th>
                </tr>
                </thead>
                <tbody>
                    {users.map(user => <tr key={user.u}>
                            <td style={{verticalAlign: "middle"}}>
                                {user.u}
                            </td>
                            <td style={{verticalAlign: "middle"}}>
                            <EuiCheckbox
                                id={`${user.u}-2fa`}
                                label="2FA Enabled"
                                checked={user["2fa"]}
                                onChange={handleToggle2FA(user.u)}
                            />
                            </td>
                            <td style={{verticalAlign: "middle"}}>
                                <button 
                                    className="btn btn-outline-light btn-sm" 
                                    style={{padding: 10, margin: 5, borderStyle: "solid", borderWidth: 1}}
                                    onClick={handleDelete(user.u)}
                                >
                                    <svg className="bi bi-x-circle-fill" width="1.5em" height="1.5em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM7.354 6.646L10 9.293l2.646-2.647a.5.5 0 01.708.708L10.707 10l2.647 2.646a.5.5 0 01-.708.708L10 10.707l-2.646 2.647a.5.5 0 01-.708-.708L9.293 10 6.646 7.354a.5.5 0 11.708-.708z" clipRule="evenodd"></path>
                                    </svg>
                                    <span style={{paddingLeft: 5}}>Delete</span>
                                </button>  
                                <button 
                                    className="btn btn-outline-light btn-sm" 
                                    style={{padding: 10, margin: 5, borderStyle: "solid", borderWidth: 1}}
                                    onClick={handleUpdatePassword(user.u)}
                                >
                                    <svg className="bi bi-gear-fill" width="1.5em" height="1.5em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M14.34 12.486l1.317 1.757-1.414 1.414-1.757-1.318c-.365.21-.76.375-1.176.487L11 17H9l-.31-2.174a4.969 4.969 0 01-1.176-.487l-1.757 1.318-1.414-1.414 1.318-1.757a4.968 4.968 0 01-.487-1.176L3 11V9l2.173-.31a4.97 4.97 0 01.488-1.176L4.343 5.757l1.414-1.414 1.757 1.318a4.97 4.97 0 011.176-.487L9 3h2l.31 2.173c.416.113.81.278 1.176.488l1.757-1.318 1.414 1.414-1.318 1.757c.21.365.375.76.487 1.176L17 9v2l-2.174.31c-.112.416-.277.81-.487 1.176zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd"></path>
                                        <path d="M15.657 14.243l.353.353a.5.5 0 00.047-.653l-.4.3zm-1.414 1.414l-.3.4a.5.5 0 00.653-.047l-.353-.353zm-1.757-1.318l.3-.4a.5.5 0 00-.55-.033l.25.433zm-1.176.487l-.13-.482a.5.5 0 00-.364.412l.494.07zM11 17v.5a.5.5 0 00.495-.43L11 17zm-2 0l-.495.07A.5.5 0 009 17.5V17zm-.31-2.174l.494-.07a.5.5 0 00-.364-.412l-.13.482zm-1.176-.487l.25-.433a.5.5 0 00-.55.033l.3.4zm-1.757 1.318l-.353.353a.5.5 0 00.653.047l-.3-.4zm-1.414-1.414l-.4-.3a.5.5 0 00.047.653l.353-.353zm1.318-1.757l.4.3a.5.5 0 00.033-.55l-.433.25zm-.487-1.176l.482-.13a.5.5 0 00-.412-.364l-.07.494zM3 11h-.5a.5.5 0 00.43.495L3 11zm0-2l-.07-.495A.5.5 0 002.5 9H3zm2.173-.31l.071.494a.5.5 0 00.412-.364l-.482-.13zm.488-1.176l.433.25a.5.5 0 00-.033-.55l-.4.3zM4.343 5.757l-.353-.353a.5.5 0 00-.047.653l.4-.3zm1.414-1.414l.3-.4a.5.5 0 00-.653.047l.353.353zm1.757 1.318l-.3.4a.5.5 0 00.55.033l-.25-.433zm1.176-.487l.13.482a.5.5 0 00.364-.412l-.494-.07zM9 3v-.5a.5.5 0 00-.495.43L9 3zm2 0l.495-.07A.5.5 0 0011 2.5V3zm.31 2.173l-.495.071a.5.5 0 00.365.412l.13-.482zm1.176.488l-.25.433a.5.5 0 00.55-.033l-.3-.4zm1.757-1.318l.353-.353a.5.5 0 00-.653-.047l.3.4zm1.414 1.414l.4.3a.5.5 0 00-.047-.653l-.353.353zm-1.318 1.757l-.4-.3a.5.5 0 00-.033.55l.433-.25zm.487 1.176l-.482.13a.5.5 0 00.412.364l.07-.494zM17 9h.5a.5.5 0 00-.43-.495L17 9zm0 2l.07.495A.5.5 0 0017.5 11H17zm-2.174.31l-.07-.495a.5.5 0 00-.412.365l.482.13zm-.887 1.476l1.318 1.757.8-.6-1.318-1.757-.8.6zm1.364 1.103l-1.414 1.414.707.707 1.414-1.414-.707-.707zm-.76 1.368l-1.757-1.318-.6.8 1.757 1.318.6-.8zm-2.306-1.351a4.472 4.472 0 01-1.057.438l.261.965a5.47 5.47 0 001.294-.536l-.498-.867zm-1.421.85l-.311 2.173.99.142.31-2.174-.99-.141zM11 16.5H9v1h2v-1zm-1.505.43l-.31-2.174-.99.141.31 2.174.99-.142zm-.675-2.586a4.472 4.472 0 01-1.057-.438l-.498.867a5.5 5.5 0 001.294.536l.261-.965zm-1.606-.405l-1.757 1.318.6.8 1.757-1.318-.6-.8zm-1.103 1.364L4.697 13.89l-.707.707 1.414 1.414.707-.707zm-1.368-.76l1.318-1.757-.8-.6-1.318 1.757.8.6zm1.351-2.306a4.47 4.47 0 01-.438-1.057l-.965.261c.124.458.305.892.536 1.294l.867-.498zm-.85-1.421l-2.173-.311-.142.99 2.174.31.141-.99zM3.5 11V9h-1v2h1zm-.43-1.505l2.174-.31-.141-.99-2.174.31.142.99zm2.586-.675a4.47 4.47 0 01.438-1.057l-.867-.498a5.47 5.47 0 00-.536 1.294l.965.261zm.405-1.606L4.743 5.457l-.8.6 1.318 1.757.8-.6zM4.697 6.111L6.11 4.697l-.707-.707L3.99 5.404l.707.707zm.76-1.368l1.757 1.318.6-.8-1.757-1.318-.6.8zm2.306 1.351a4.47 4.47 0 011.057-.438l-.261-.965a5.47 5.47 0 00-1.294.536l.498.867zm1.421-.85l.311-2.173-.99-.142-.31 2.174.99.141zM9 3.5h2v-1H9v1zm1.505-.43l.31 2.174.99-.141-.31-2.174-.99.142zm.675 2.586c.374.101.728.25 1.057.438l.498-.867a5.47 5.47 0 00-1.294-.536l-.261.965zm1.606.405l1.757-1.318-.6-.8-1.757 1.318.6.8zm1.103-1.364l1.414 1.414.707-.707-1.414-1.414-.707.707zm1.368.76l-1.318 1.757.8.6 1.318-1.757-.8-.6zm-1.351 2.306c.188.329.337.683.438 1.057l.965-.261a5.47 5.47 0 00-.536-1.294l-.867.498zm.85 1.421l2.173.311.142-.99-2.174-.31-.141.99zM16.5 9v2h1V9h-1zm.43 1.505l-2.174.31.141.99 2.174-.31-.142-.99zm-2.586.675a4.49 4.49 0 01-.438 1.057l.867.498a5.47 5.47 0 00.536-1.294l-.965-.261zM10 13.5a3.5 3.5 0 003.5-3.5h-1a2.5 2.5 0 01-2.5 2.5v1zm3.5-3.5A3.5 3.5 0 0010 6.5v1a2.5 2.5 0 012.5 2.5h1zM10 6.5A3.5 3.5 0 006.5 10h1A2.5 2.5 0 0110 7.5v-1zM6.5 10a3.5 3.5 0 003.5 3.5v-1A2.5 2.5 0 017.5 10h-1z"></path>
                                    </svg>
                                    <span style={{paddingLeft: 5}}>Reset Password</span>
                                </button>            

                                <button 
                                    className="btn btn-outline-light btn-sm" 
                                    style={{padding: 10, margin: 5, borderStyle: "solid", borderWidth: 1}}
                                    onClick={handleShow2faQR(user.u)}
                                >
                                    <EuiIcon 
                                        type="fullScreen"
                                    />
                                    <span style={{paddingLeft: 5}}>2FA QR</span>
                                </button>             
                                
                            </td>
                        </tr>)}                
                    <tr>
                        <td style={{verticalAlign: "middle"}} />
                        <td style={{verticalAlign: "middle"}} />
                        <td style={{verticalAlign: "middle", textAlign: "right"}}>
                            <button 
                                className="btn btn-outline-light btn-sm" 
                                style={{padding: 10, margin: 5, borderStyle: "solid", borderWidth: 1}}
                                onClick={handleCreateUser}
                            >
                                <svg className="bi bi-people-fill" width="1.5em" height="1.5em" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" d="M9 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H9zm4-6a3 3 0 100-6 3 3 0 000 6zm-5.784 6A2.238 2.238 0 017 15c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 007 11c-4 0-5 3-5 4s1 1 1 1h4.216zM6.5 10a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" clipRule="evenodd"></path>
                                </svg>
                                <span style={{paddingLeft: 5}}>Create New User</span>
                            </button> 
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        )
    },[users])

    useEffect(()=>{
        let users = []

        switch (CONFIG.mode) {    
            case 'PROD':        
            case "DEV":
                Axios.get(CONFIG.api.userGetAll).then(resp => {
                    users = resp.data
                    changeUsers(users)
                })
                .catch(err => console.log(err))       
                break;        
            default:
                users = [{
                    u: "admin",
                    "2fa": true
                }, {
                    u: "demoUser",
                    "2fa": true
                }, {
                    u: "anotherDemoUser",
                    "2fa": false
                },]                
                changeUsers(users)
                break;
        }        
        
    },[])

    return <React.Fragment>
        { content ? content
        : 
            <BeatLoader
                loading={true}
                color="#36D7B7"
            /> 
        }
        <div class="modal" tabindex="-1" role="dialog" id="userManagementModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{modal.title}</h5>
                    <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {modal.body}                           
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" onClick={modal.action}>OK</button>
                </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="user2faQr">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">2FA QR Code</h5>
                    <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="qrCode"/>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
                </div>
            </div>
        </div>
    </React.Fragment>
        
}

export default UserTable